module.exports = "https://statics.teams.cdn.live.net/hashedassets-launcher/v2/continue_primary.0d5b496c234c245d7dd65c8ebbef5891.svg";